import api from './api'

const API_URL = process.env.VUE_APP_API_URL || 'https://empirecanada.ca/api';

console.log('🔧 Configuração da API no searchService:', {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL,
  API_URL: API_URL,
  baseURL: api.defaults.baseURL
})

export const searchService = {
  /**
   * Dynamic search with reactive filters
   * Returns categories and filters with product counts
   * @param {Object} params - Search parameters
   * @param {string} params.search - Search terms
   * @param {Array<string>} params.filters - IDs of selected filters
   * @returns {Promise<Object>} Result with categories, filters, totalProducts, searchTerms
   */
  async dynamicSearch(params = {}) {
    try {
      console.log('🔍 searchService.dynamicSearch chamado com:', params)

      const queryParams = new URLSearchParams()

      if (params.search && params.search.trim()) {
        queryParams.append('search', params.search.trim())
      }

      if (params.categoryId && String(params.categoryId).trim()) {
        queryParams.append('categoryId', String(params.categoryId).trim())
      }

      if (params.filters && Array.isArray(params.filters) && params.filters.length > 0) {
        params.filters.forEach(filterId => {
          queryParams.append('filters', filterId)
        })
      }

      if (params.inStockOnly === true) {
        queryParams.append('inStockOnly', 'true')
      }

      const url = `${API_URL}/search/dynamic${queryParams.toString() ? '?' + queryParams.toString() : ''}`
      console.log('📡 Fazendo requisição para:', url)

      const response = await api.get(`/search/dynamic`, {
        params: {
          search: params.search,
          categoryId: params.categoryId,
          filters: params.filters,
          inStockOnly: params.inStockOnly === true
        }
      })

      console.log('✅ Resposta da busca dinâmica:', response.data)

      return response.data
    } catch (error) {
      console.error('❌ Erro na busca dinâmica:', error)
      throw error
    }
  },

  /**
   * Debounce helper to avoid excessive calls to the API
   * @param {Function} func - Function to be executed
   * @param {number} wait - Wait time in ms
   * @returns {Function} Debounced function
   */
  debounce(func, wait = 300) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}

export default searchService

